export const CLIENT_STATUS_ONLINE = 1;
export const CLIENT_STATUS_OFFLINE = 0;

export type ClientStatus = 1 | 0;